module.exports = __webpack_public_path__ + "static/project2-0d7f6c8a17dc636f9059fc0c17d4bd46.png";